import React, { useState, useEffect } from 'react';
import { Loader2, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

// Écart de réception : quantité réellement reçue + commentaire obligatoire
const ReceptionDialog = ({ line, open, onOpenChange, onConfirm, busy }) => {
  const [qty, setQty] = useState('');
  const [comment, setComment] = useState('');
  useEffect(() => { if (open) { setQty(line ? String(line.quantity) : ''); setComment(''); } }, [open, line]);
  const q = parseFloat(qty);
  const valid = !Number.isNaN(q) && q >= 0 && comment.trim().length > 0;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!busy) onOpenChange(v); }}>
      <DialogContent className="bg-white border-gray-200 max-w-md" data-testid="reception-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-gray-900 flex items-center gap-2"><AlertTriangle className="text-red-500" size={20} />Écart à la réception</DialogTitle>
          <DialogDescription className="text-gray-500">{line?.product_name} · commandé {line?.quantity} {line?.unit}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-gray-700">Quantité réellement reçue ({line?.unit})</Label>
            <Input type="number" inputMode="decimal" step="any" min="0" value={qty} onChange={(e) => setQty(e.target.value)} className="mt-1 h-12 rounded-xl bg-gray-100 border-gray-200 text-gray-900 text-lg" data-testid="reception-qty-input" autoFocus />
            <p className="text-xs text-gray-400 mt-1">0 = produit manquant / non livré</p>
          </div>
          <div>
            <Label className="text-gray-700">Commentaire (obligatoire)</Label>
            <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Ex : 2 kg manquants, cageot abîmé, DLC trop courte…" className="mt-1 rounded-xl bg-gray-100 border-gray-200 text-gray-900 min-h-[90px]" data-testid="reception-comment-input" />
          </div>
        </div>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} className="flex-1 h-12 rounded-full border-gray-300" data-testid="reception-cancel-btn">Annuler</Button>
          <Button onClick={() => onConfirm(q, comment.trim())} disabled={!valid || busy} className="flex-1 h-12 rounded-full bg-red-500 hover:bg-red-600 text-white font-semibold" data-testid="reception-confirm-btn">
            {busy ? <Loader2 size={16} className="animate-spin mr-2" /> : null}Enregistrer l'écart
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReceptionDialog;
